import { Routes } from '@angular/router';

export const CHARGERS_ROUTES: Routes = [
  {
    path: 'chargers',
    loadComponent: () =>
      import('./chargers-list/chargers-list.component')
        .then(m => m.ChargersListComponent),
  }
];
